import React, { useEffect, useState } from 'react';
import SelectorMultiple from '../../../../../shared/Components/Selectores/Multiple';
import { createOptions } from './functions';


export const SelectorMonedas = (props:any) =>{

  console.log('SelectorMonedas ', props)
  let {options, selectedOptions, onChange} = props;
  let [comboOptions, setComboOptions] = useState(options)

  useEffect(()=>{
    if(options){
      setComboOptions(createOptions(options))
    }
  },[options])

  useEffect(()=>{
    console.log('cambia comboOptions 1', comboOptions)
    if(comboOptions  && comboOptions.length>0)
    {
      console.log('cambia comboOptions 2', comboOptions)
      let select = !Array.isArray(selectedOptions) ? comboOptions.filter((o:any) => o.value===selectedOptions) : selectedOptions
      onChange && onChange(select)
    }
  },[comboOptions])
 
  return (
    <SelectorMultiple {...{...props,...{options:(comboOptions)}}} id="comboMonedas"/>
  )

  // useEffect(()=>{
  //   if(data)
  //   {setOptions(getOptions())}
  //   // if(data.length > 0 && !disabled) change(data[0].iso)
  //   // else if (disabled) change(undefined)
  // },[data, disabled])
  
  // const change = (value:any) =>{
  //   onChange(value)
  // }

  // const getOptions = () =>{
  //   return data.map((p: MonedaEntity)=> { return { value: p.iso, inputDisplay: p.name } })
  // }

  // return (
  //   <SelectorSimple {...props} options={options} onChange={change} name="selectMonedas"/>
  // )
}
export default SelectorMonedas